export default {
    SET_PROJECT_COSTS(state, costs) {
      state.projectCosts = costs;
    },
    ADD_PROJECT_COST(state, cost) {
      state.projectCosts.unshift(cost);
    },
    REMOVE_PROJECT_COST(state, id) {
      state.projectCosts = state.projectCosts.filter((cost) => cost.id !== id);
    },
    LOADING_PROJECT_COST(state, isLoading) {
      state.loading = isLoading;
    },
    SET_SINGLE_PROJECT_COST(state, cost) {
      state.projectCosts = [cost]; // Replace existing costs with the fetched cost
    },
  };
  